import React from 'react'
import Header from '../Header/Header'
import TiendasData from '../../Components/Admin/TiendasData/TiendasData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'

export default function Tiendas() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <TiendasData />

                </div>
            </section>
        </div>
    )
}

